<template>
  <div>
    <div style="background-position: center; background-size: cover">
      <div id="anm22_wb_login_pagebody_conteiner" style="background: none">
        <div class="anm22-calendar-wrapper">
          <div class="anm22-calendar-field labelEventName">
            <b>{{ event[0].name }}</b>
          </div>
          <div class="clear"></div>
          <div class="anm22-calendar-label-tiny-inline labelDateFrom">
            Inizio
          </div>
          <div class="anm22-calendar-field-inline">
            {{
              this.$moment
                .unix(event[0].startTimestamp)
                .format("DD-MM-YYYY HH:mm")
            }}
          </div>
          <div class="clear"></div>
          <div class="anm22-calendar-label-tiny-inline labelDateTo">Fine</div>
          <div class="anm22-calendar-field-inline">
            {{
              this.$moment
                .unix(event[0].endTimestamp)
                .format("DD-MM-YYYY HH:mm")
            }}
          </div>
        </div>
        <template v-if="event[0].placeStreet != ''">
          <div class="anm22-calendar-wrapper">
            <div class="anm22-calendar-field labelEventName">
              Luogo<span class="labelFieldPlace"></span>
            </div>
            <div class="clear"></div>
            <div class="anm22-calendar-label-tiny-inline">
              Nome Luogo: {{ event[0].placeName }}
            </div>
            <div class="clear"></div>
            <div class="anm22-calendar-label-tiny-inline">
              Indirizzo: {{ event[0].placeStreet }}
            </div>
            <div class="clear"></div>
            <div class="anm22-calendar-label-tiny-inline">
              Città: {{ event[0].placeCity }} {{ event[0].placeState }}
              {{ event[0].placeZip }}
            </div>
            <div class="clear"></div>
          </div>
        </template>
        <div class="anm22-calendar-wrapper" v-if="invite[0].status > 0">
          <template
            ><b>Stato Invito:</b>
            {{
              $anm22.tableClasses.inviteStatus().getById(invite[0].status)["it"]
            }}
            <div style="display: block">
              <br />
              <div class="anm22-calendar-invite-state" style="cursor: pointer">
                <img
                  :src="$anm22.icons.getWorldIcon('tick')"
                  class="anm22-calendar-icon-inline"
                />
                <div class="anm22-calendar-field-inline">
                  <small
                    @click="
                      eventStatus(
                        event[0].idWorldEvent,
                        invite[0].idWorldEventInvite,
                        2
                      )
                    "
                    >{{
                      $anm22.strLang(lang, "Parteciperò", "Parteciperò")
                    }}</small
                  >
                </div>
              </div>
              <div class="anm22-calendar-invite-state" style="cursor: pointer">
                <img
                  :src="$anm22.icons.getWorldIcon('deleteRed')"
                  class="anm22-calendar-icon-inline"
                />
                <div class="anm22-calendar-field-inline">
                  <small
                    @click="
                      eventStatus(
                        event[0].idWorldEvent,
                        invite[0].idWorldEventInvite,
                        3
                      )
                    "
                    >{{
                      $anm22.strLang(lang, "Non Parteciperò", "Non Parteciperò")
                    }}</small
                  >
                </div>
              </div>
              <div
                class="anm22-calendar-invite-state-last"
                style="cursor: pointer"
              >
                <img
                  :src="$anm22.icons.getWorldIcon('maybe')"
                  class="anm22-calendar-icon-inline"
                />
                <div class="anm22-calendar-field-inline">
                  <small
                    @click="
                      eventStatus(
                        event[0].idWorldEvent,
                        invite[0].idWorldEventInvite,
                        4
                      )
                    "
                    >{{ $anm22.strLang(lang, "Forse", "Forse") }}</small
                  >
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    this.$http.get("events");
    if (this.$route.params.id) {
      let slugs = this.$route.params.id;
      let slug = slugs.split(",");
      let idWorldEvent = slug[0];
      let idWorldEventInvite = slug[1];
      let status = slug[2];
      if (status && idWorldEventInvite) {
        this.updateStatus(idWorldEvent, idWorldEventInvite, status);
      } else if (idWorldEvent) {
        this.showEvent(idWorldEvent, idWorldEventInvite);
      }
    }
  },

  methods: {
    updateStatus(idWorldEvent, idWorldEventInvite, status) {
      this.$http
        .post(
          "events/statusinvite",
          {
            idWorldEvent: idWorldEvent,
            idWorldEventInvite: idWorldEventInvite,
            status: status,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          console.log(response.data);
          return Promise.all([
            this.$store.dispatch("invites/update", {
              vlf: this.$vlf("invite"),
              objs: [response.data.invite],
            }),
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("event"),
              objs: [response.data.event],
            }),
          ]);
        })
        .catch((error) => console.log(error));
    },

    eventStatus(idWorldEvent, idWorldEventInvite, status) {
      this.$http
        .post(
          "events/updatestatusinvited",
          {
            idWorldEvent: idWorldEvent,
            idWorldEventInvite: idWorldEventInvite,
            status: status,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          //console.log(response.data);
          this.$store.dispatch("invites/update", {
            vlf: this.$vlf("invite"),
            objs: [response.data.invite],
          });
        })
        .catch((error) => {});
    },

    showEvent(idWorldEvent, idWorldEventInvite) {
      this.$http
        .post(
          "events/showevent",
          {
            idWorldEvent: idWorldEvent,
            idWorldEventInvite: idWorldEventInvite,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          console.log(response.data);
          return Promise.all([
            this.$store.dispatch("invites/update", {
              vlf: this.$vlf("invite"),
              objs: [response.data.invite],
            }),
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("event"),
              objs: [response.data.event],
            }),
          ]);
        })
        .catch((error) => console.log(error));
      this.$Progress.finish();
    },
  },

  computed: {
    event() {
      return this.$store.getters["events/getAll"];
    },
    invite() {
      return this.$store.getters["invites/getAll"];
    },
  },
};
</script>
